module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/poster-boom-cfe37d00151ac79e1099c6e19f91a3d7.png";